import { apiPut } from "../ApiMethod";
import { setRole } from "../../mappers";

export const updateRole = async (data, id) => {
  const response = await apiPut("_role", id, data);
  return { ...response, data: setRole(response.data) };
};